module.exports = __webpack_public_path__ + "img/repo.88dce2d6.svg";